var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 9.99998V3.33331M15.8333 16.6666V14.1666M4.16663 16.6666V13.3333M15.8333 10.8333V3.33331M9.99996 5.83331V3.33331M9.99996 16.6666V9.16665",
    stroke: "#1C4E9D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 13.3333C5.08714 13.3333 5.83333 12.5871 5.83333 11.6667C5.83333 10.7462 5.08714 10 4.16667 10C3.24619 10 2.5 10.7462 2.5 11.6667C2.5 12.5871 3.24619 13.3333 4.16667 13.3333Z",
    stroke: "#1C4E9D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.16665C10.9205 9.16665 11.6667 8.42045 11.6667 7.49998C11.6667 6.57951 10.9205 5.83331 10 5.83331C9.07957 5.83331 8.33337 6.57951 8.33337 7.49998C8.33337 8.42045 9.07957 9.16665 10 9.16665Z",
    stroke: "#1C4E9D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 14.1666C16.7538 14.1666 17.5 13.4205 17.5 12.5C17.5 11.5795 16.7538 10.8333 15.8333 10.8333C14.9128 10.8333 14.1666 11.5795 14.1666 12.5C14.1666 13.4205 14.9128 14.1666 15.8333 14.1666Z",
    stroke: "#1C4E9D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.79e03972d3e3bc51e9ce8a4a876a486b.svg";
export { ForwardRef as ReactComponent };